export const SET_ACCOUNT_OPEN = 'SET_ACCOUNT_OPEN';

export interface SetAccountOpen {
  type: typeof SET_ACCOUNT_OPEN;
  isAccountOpen: boolean;
}

export type UserActions = SetAccountOpen